import { StateCreator } from 'zustand';

import {
  ChooseTeamPlanFlowState,
  CreateTeamFlowState,
  TeamsStoreState,
} from './types';

export const stateCreator: StateCreator<TeamsStoreState> = (set) => ({
  showCreateTeamModal: false,
  createTeamFlowState: CreateTeamFlowState.CreateTeam,
  chooseTeamPlanFlowState: ChooseTeamPlanFlowState.ChooseTeamPlan,

  setShowCreateTeamModal: (showCreateTeamModal: boolean): void => {
    set({ showCreateTeamModal });
  },
  setCreateTeamFlowState: (createTeamFlowState: CreateTeamFlowState): void => {
    set({ createTeamFlowState });
  },
  setChooseTeamPlanFlowState: (
    chooseTeamPlanFlowState: ChooseTeamPlanFlowState
  ): void => {
    set({ chooseTeamPlanFlowState });
  },
});
